import React, { useEffect, useState } from 'react';
import { Grid, Typography, Button } from '@mui/material';
import { IKeycloakTeam } from '../../pages/superAdmin/TeamAccess';
import GroupAPI from 'api/GroupAPI';

interface IServiceAccountProps {
  serviceAccountGroups: any[],
  removeDatahubAccess: any,
  addDatahubAccess: any
}

const ServiceAccounts: React.FC<IServiceAccountProps> = (props: IServiceAccountProps) => {
  const { serviceAccountGroups, removeDatahubAccess, addDatahubAccess } = props;
  const [ serviceAccounts, setServiceAccounts ] = useState<any[]>([]);
  const serviceAccountsArr: IKeycloakTeam[] = [];

  const filterServiceAccounts = async(teamsFromProps: IKeycloakTeam[]) => {
    await Promise.all(
      teamsFromProps.map(async(team: IKeycloakTeam) => {
        const res = await GroupAPI.getGroupById(team.id);
        if (res?.success) {
          serviceAccountsArr.push(res.result);
        }
      })
    );
    setServiceAccounts(serviceAccountsArr);
  };

  useEffect(() => {
    filterServiceAccounts(serviceAccountGroups);
  }, [ serviceAccountGroups ]);

  return (
    <div>
      <Grid item xs={12} lg={6} md={6} sm={6}>
        {serviceAccounts.map((acct: any, index: number) => {
          return (
            <div key={index}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <div className='service-acct-box'>
                  <div>
                    <Typography className='text-white' variant='h6' component='h2'>
                      {acct.name}
                    </Typography>
                  </div>
                  {!acct.realmRoles?.includes('datahub') ? (
                    <div>
                      <Button className='Theme-Btn' onClick={() => addDatahubAccess(acct.id, acct.name)}>
                        Enable
                      </Button>
                    </div>
                  ) : (
                    <div>
                      <Button className='Theme-Btn-red' onClick={() => removeDatahubAccess(acct.id, acct.name)}>
                        Disable
                      </Button>
                    </div>
                  )}
                </div>
              </Grid>
            </div>
          );
        })
        }
      </Grid>
    </div>
  );
};

export default ServiceAccounts;
